import { useEffect, useState } from "react";
import { Dropdown, DropdownItemProps, DropdownProps } from "semantic-ui-react";
import { restRequest } from "../../http";
import _ from "lodash";
import { LewittProduct } from "../../models/common_model";
import { DropdownOption } from "../../models/testing_model";


const NoneValue = '-None-'
export function LewittProjectDropdown(props: DropdownProps & { value: string, emptyText?: string, onChange: (v: string) => void , placeholder?: string }) {
    const sServerProjects = useState<DropdownItemProps[]>([]);
    const sName = useState('');
    const sLoading = useState(false);
    useEffect(() => {
        sLoading[1](true);
        restRequest<LewittProduct[]>('commons/lewitt_projects', { name: sName[0] }, 'post').then(values => {
            sServerProjects[1](values.map(s => ({ text: s.name, value: s.name, key: s.name })));
        }).finally(() => sLoading[1](false));
    }, [sName[0]]);

    let options: DropdownItemProps[] = [];
    if (!props.required) {
        options.push({ text: props.emptyText || '-None-', value: NoneValue, key: '-None-' });
    }
    options = _.concat(options, sServerProjects[0]);


    if (props.value && !options.find(o => o.value === props.value)) {
        options.push({ text: props.value, value: props.value, key: props.value });
    }

    return <Dropdown {...props} 
    options={options}
        value={props.value || NoneValue}
        onChange={(e, d) => {
            let value = d.value as string;
            if (value === NoneValue) {
                value = '';
            }

            props.onChange(value);
        }}
        onBlur={(e, d) => {
            if (d.value) {
                let trimValue = (d.value as string).trim();
                if (trimValue === NoneValue) {
                    trimValue = '';
                }
                if (trimValue != props.value) {
                    props.onChange(trimValue);
                }
            }
        }}
        onSearchChange={(e, d) => {
            sName[1]((e.target as any).value as string);
        }}
        onAddItem={(e, d) => {
            let value = d.value as string;
            if (value) {
                sName[1]('');
            }
        }}
        loading={sLoading[0]}

        search selection fluid allowAdditions

        placeholder = {props.placeholder}
    />
}